import { createFileRoute } from "@tanstack/react-router";
import Impersonate from "@/pages/Impersonate";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/impersonate")({
  head: () => seoHead({ title: "Impersonation", noindex: true }),
  component: Impersonate,
});
